import { render, staticRenderFns } from "./AcademyLexicon.vue?vue&type=template&id=ee145a7e&scoped=true&"
import script from "./AcademyLexicon.vue?vue&type=script&lang=js&"
export * from "./AcademyLexicon.vue?vue&type=script&lang=js&"
import style0 from "./AcademyLexicon.vue?vue&type=style&index=0&id=ee145a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee145a7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
